import React from 'react';
import { Star } from 'react-feather';

interface StarRatingProps {
	value: number;
	max?: number;
	size?: number;
	showValue?: boolean;
}

const StarRating: React.FC<StarRatingProps> = ({ value, max = 5, size = 14, showValue = true }) => {
	const clampedValue = Math.min(Math.max(value, 0), max);

	return (
		<div className="flex items-center gap-2">
			<div className="flex items-center gap-1" aria-label={`${clampedValue}/${max}`}>
				{Array.from({ length: max }).map((_, index) => {
					const fillRatio = Math.min(Math.max(clampedValue - index, 0), 1);
					return (
						<span key={index} className="relative inline-flex">
							<Star size={size} className="text-gray-300" />
							<span
								className="absolute left-0 top-0 overflow-hidden"
								style={{ width: `${fillRatio * 100}%` }}
							>
								<Star size={size} className="text-yellow-400" fill="currentColor" />
							</span>
						</span>
					);
				})}
			</div>
			{showValue && (
				<span className="text-sm font-medium">
					{clampedValue}/{max}
				</span>
			)}
		</div>
	);
};

export default StarRating;
